// extracted by mini-css-extract-plugin
export default {"companyStatsDateForm":"companyStatsDateForm_companyStatsDateForm__m6GSe"};